import EmptyDottedIcon from '@assets/icons/empty-dotted.svg';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { EmptyState } from '@experiences/components/empty-state';

interface Props {
  description: string;
  title: string;
}

export const CustomersTableEmptyState: React.FC<Props> = ({
  description,
  title,
}) => {
  const [styles, theme] = useStyles();

  return (
    <EmptyState
      containerStyle={styles.container}
      description={description}
      iconElement={
        <EmptyDottedIcon
          height={48}
          stroke={theme.sk.color.icon.primary}
          width={48}
        />
      }
      title={title}
    />
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    paddingVertical: theme.sk.spacing.space5xlarge,
  },
}));
